import React from 'react'
import * as Yup from 'yup'
import { get } from 'lodash'
import { Field, Formik, Form } from 'formik'
import styled from 'styled-components'
import { Text, Row, Column, FormikInput, Button, FlexContainer } from '../src/components/common'
import withAWSAuth from '../src/hoc/withAWSAuth'
import AuthWrapper, { RequestErrorWrapper } from '../src/components/layouts/Auth/Auth.wrapper'
import Link from '../src/components/routes/Link';

const ValidationSchema = Yup.object().shape({
    username: Yup.string()
        .email('form.validations.email')
        .required('form.validations.required')
})

const FormContainer = styled(FlexContainer)``

const ForgotPasswordDisplayForm = ({ errors, dirty, isSubmitting, handleSubmit, handleChange, handleReset, submitCount, isValid, ...props }) => (
    (
        <Form onSubmit={handleSubmit} onReset={handleReset}>
            <FormContainer direction='column'>
                <Row>
                    <Column justify='flex-end'>
                        <Text text='form.forgot_password.title' style={{ fontSize: '1.25rem', color: '#333333' }} />
                        <Text text='form.forgot_password.subtitle' style={{ fontSize: '1rem', margin: '5px 0px 10px 0px' }} />
                    </Column>
                </Row>
                <Row>
                    <Column>
                        <Field
                            style={{ padding: 0 }}
                            component={FormikInput}
                            name='username'
                            type='input'
                            label='Usuario'
                            hasFeedback
                            placeholder='usuario@mail.com'
                            disabled={isSubmitting}
                            allowClear
                            submitCount={submitCount}
                        />
                    </Column>
                </Row>
                {errors && errors['response'] && <Row>
                    <Column>
                        <RequestErrorWrapper>
                            <Text text={errors['response']} />
                        </RequestErrorWrapper>
                    </Column>
                </Row>}
                <Row style={{ margin: '15px 0px' }}>
                    <Button type='submit' className='login-form-button' disabled={isSubmitting || !isValid} loading={isSubmitting} text='form.forgot_password.btn.submit' />
                </Row>
            </FormContainer >
        </Form>
    )
)
const ForgotPasswordRequestForm = ({ handleSubmit, handleReset, initialValues, isSubmitting }) => (
    <Formik
        onSubmit={handleSubmit}
        onReset={handleReset}
        initialValues={initialValues}
        validationSchema={ValidationSchema}
        render={ForgotPasswordDisplayForm}
    />
)

class ForgotPasswordRequest extends React.Component {
    handleSubmit = (values, { setSubmitting, setFieldError }) => {
        const { awsAuth } = this.props
        const username = get(values, 'username')
        setSubmitting(true)
        awsAuth.forgotPassword(values)
            .then(() => Promise.resolve(window.localStorage.setItem('rp_auth_username', username)))
            .then((resp) => this.props.history.push(`/update-password?u=${encodeURIComponent(username)}`))
            .catch((err) => {
                const errorCode = get(err, 'code')
                setFieldError('response', `form.auth.error.${errorCode}`)
                setSubmitting(false)
            })
    };

    render () {
        return (
            <AuthWrapper>
                <ForgotPasswordRequestForm handleSubmit={this.handleSubmit.bind(this)} initialValues={{ username: '' }} />
                <Row justify='center'>
                    <Link style={{ textAlign: 'center' }} href='/login'>Volver</Link>
                </Row>
            </AuthWrapper>
        )
    }
}
export default withAWSAuth(ForgotPasswordRequest)
